import React from "react";
import {Box, Tooltip} from "@mui/material";
import {InfoOutlined} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {RequestI18N} from "@/translations";
import {TOOLTIP_DELAY_MS} from "@/constants";

/**
 * Renders the header for the distance-to-requester column with an info tooltip.
 */
export const RequestDistanceHeader: React.FC = () => {
    const {t} = useTranslation();
    return (
        <Box display="inline-flex" alignItems="center" gap="4px">
            {t(RequestI18N.details.field.distanceToRequester)}
            <Tooltip
                title={t(RequestI18N.details.tooltip.distanceColumn)}
                enterDelay={TOOLTIP_DELAY_MS}
                enterNextDelay={TOOLTIP_DELAY_MS}
                arrow
            >
                {/* DataTableColumnHeader wraps the whole header content in its dropdown-trigger button
                    (DataTableColumnHeader.tsx), so a click here bubbles into that button's onClick and opens
                    the dropdown unless it is stopped in the capture phase. onClickCapture, not onClick: the
                    span never receives focus, so jsx-a11y/click-events-have-key-events would demand a dead
                    keyboard handler for an onClick it does not require for onClickCapture. */}
                <span onClickCapture={(event) => event.stopPropagation()}>
                    <InfoOutlined
                        fontSize="small"
                        color="inherit"
                        style={{cursor: "pointer", verticalAlign: "middle"}}
                        aria-label={t(RequestI18N.details.tooltip.distanceColumn)}
                    />
                </span>
            </Tooltip>
        </Box>
    );
};
